import { createAction } from 'redux-actions';
import {
	CheckoutOrderFragment,
	ExchangeOrderFragment,
	GdsServicesRefundOrderFragment,
	RefundOrderFragment
} from '@websky/graphql';

export const SET_ORDER = 'SET_ORDER';
export const FILL_ORDER = 'FILL_ORDER';
export const SET_LAST_REFUND = 'SET_LAST_REFUND';
export const SET_LAST_GDS_SERVICES_REFUND = 'SET_LAST_GDS_SERVICES_REFUND';
export const SET_LAST_EXCHANGE = 'SET_LAST_EXCHANGE';
export const CLEAR_LAST_EXCHANGE = 'CLEAR_LAST_EXCHANGE';
export const ANALYZE_PURCHASEd_PRODUCTS = 'ANALYZE_PURCHASEd_PRODUCTS';

export const setOrder = createAction<CheckoutOrderFragment>(SET_ORDER);

export type SetOrderAction = ReturnType<typeof setOrder>;

export const fillOrder = createAction<CheckoutOrderFragment>(FILL_ORDER);

export type FillOrderAction = ReturnType<typeof fillOrder>;

export const setLastRefund = createAction<RefundOrderFragment>(SET_LAST_REFUND);

export type SetLastRefundAction = ReturnType<typeof setLastRefund>;

export const setLastGdsServicesRefund = createAction<GdsServicesRefundOrderFragment>(SET_LAST_GDS_SERVICES_REFUND);

export type SetLastGdsServicesRefundAction = ReturnType<typeof setLastGdsServicesRefund>;

export const setLastExchange = createAction<ExchangeOrderFragment>(SET_LAST_EXCHANGE);

export type SetLastExchangeAction = ReturnType<typeof setLastExchange>;

export const clearLastExchange = createAction(CLEAR_LAST_EXCHANGE);

export type ClearLastExchangeAction = ReturnType<typeof clearLastExchange>;

export const analyzePurchasedProducts = createAction(ANALYZE_PURCHASEd_PRODUCTS);

export type ActionTypes =
	| SetOrderAction
	| FillOrderAction
	| SetLastRefundAction
	| SetLastGdsServicesRefundAction
	| SetLastExchangeAction
	| ClearLastExchangeAction;
